export const PIELEAF_ROUTES = {
  dataDeletion: '/data-deletion',
  home: '/',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
} as const;
